"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateModuleStats = void 0;
function aggregateModuleStats(modules) {
    const numberOfModules = modules.length;
    const modulesTested = modules.filter(m => m.testingActive).length;
    return {
        averageScore: calculateAverageScore(modules, modulesTested),
        modulesCorrect: modules.filter(m => m.testingActive && m.score && !isNaN(m.score) && m.score === 1).length,
        modulesGaveUp: modules.filter(m => m.gaveUp).length,
        modulesIncorrect: modules.filter(m => m.testingActive && typeof m.score === 'number' && m.score < 1).length,
        modulesStudied: numberOfModules,
        modulesTested
    };
}
exports.aggregateModuleStats = aggregateModuleStats;
function calculateAverageScore(modules, numberOfModules) {
    const totalScore = modules.reduce((total, m) => {
        if (m.testingActive && m.score) {
            total = total + m.score;
        }
        return total;
    }, 0);
    return numberOfModules ? totalScore / numberOfModules : 0;
}
